import React, { useState, useEffect } from 'react';
import { SafeAreaView, View } from 'react-native';
import { Text, Divider, Icon, ListItem } from 'react-native-elements';
import { connect } from 'react-redux';
import { RootState } from '../redux';
import { AgentStackParamList } from '../AgentStack';
import { StackScreenProps } from '@react-navigation/stack';
import Firebase from '../components/FirebaseContext';
import { Projects } from '../utils/types/Projects';
import { Tools } from '../utils/types/Tools';
import ScreenActivity from '../components/ScreenActivity';
import { verticalScale, scale } from 'react-native-size-matters';

type ProjectProps = StackScreenProps<AgentStackParamList, 'Project'>;

function Project({ route, navigation }: ProjectProps) {
	const firestore = Firebase.firestore();
	const { docId } = route.params;
	const [project, setProject] = useState<Projects>();
	const [tools, setTools] = useState<Array<{ docId: string; tool: Tools }>>();
	const [failedFetch, setFailedFetch] = useState(false);
	useEffect(() => {
		if (docId) {
			// fetch tools
			firestore
				.collection('projects')
				.doc(docId)
				.get()
				.then((doc) => {
					if (doc.exists) {
						const p = doc.data() as Projects;
						firestore
							.collection('tools')
							.where('id', 'in', p.tools)
							.get()
							.then((res) => {
								if (!res.empty) {
									const t = res.docs.map((t) => {
										return { docId: t.id, tool: t.data() as Tools };
									});
									setTools(t);
								}
							});
						setProject(p);
					}
				})
				.catch(() => {
					setFailedFetch(true);
				});
		}
	}, [docId, firestore]);
	return (
		<SafeAreaView style={{ flex: 1, backgroundColor: '#fff' }}>
			{project ? (
				<View style={{ paddingHorizontal: scale(20), flex: 1 }}>
					<View style={{ flexDirection: 'row', marginTop: 20 }}>
						<Icon name="activity" type="feather" size={verticalScale(20)} style={{ alignSelf: 'center' }} />
						<Text style={{ fontWeight: '700', marginBottom: 20, textAlign: 'left', fontSize: verticalScale(18) }}>
							&nbsp; {project.name}
						</Text>
					</View>
					<Divider />
					{tools?.map((t) => {
						const { docId, tool } = t;
						return (
							<ListItem
								key={tool.id}
								leftAvatar={<Icon name="command" type="feather" />}
								title={tool.name}
								subtitle={tool.description}
								onPress={() => {
									navigation.navigate('Tool', { docId: docId, project: project.id });
								}}
								bottomDivider
							/>
						);
					})}
				</View>
			) : failedFetch ? (
				<View style={{ paddingHorizontal: 20, flex: 1, justifyContent: 'center' }}>
					<Text style={{ textAlign: 'center' }} h4>
						We encountered a problem loading this project. Please notify the Admin.
					</Text>
				</View>
			) : (
				<></>
			)}
			<ScreenActivity active={!tools && !failedFetch} msg="Fetching project..." />
		</SafeAreaView>
	);
}

const mapStateToProps = ({ user }: RootState) => {
	return {
		user,
	};
};

export default connect(mapStateToProps, null)(Project);
